/* eslint-disable quote-props */
export default {
  'algebra-1': 63150
};
